import { Button, Chip, Container, Grid, Stack, Typography } from '@mui/material'
import { t } from 'i18next'
import { useState } from 'react'

import Can from '../../Layout/Can/Can.jsx'
import OrganizationsList from '../List/List.jsx'

const Organizations = () => {
  const [isAddOrganizationDialogOpen, setIsAddOrganizationDialogOpen] = useState(false)

  const handleOpenOrganizationAddDialog = () => setIsAddOrganizationDialogOpen(true)

  const handleOrganizationAddDialogClose = () => setIsAddOrganizationDialogOpen(false)

  const [organizationsCount, setOrganizationsCount] = useState(0)

  const handleOrganizationsCountUpdate = (count) => {
    setOrganizationsCount(count)
  }

  return (
    <Container
      maxWidth="lg"
      sx={{ py: 3 }}>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start">
        <Grid>
          <Stack
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            spacing={2}>
            <Typography
              id="organization-header"
              variant="h2">
              {t('common.organizations')}
            </Typography>
            <Chip
              label={organizationsCount}
              color="primary"
            />
          </Stack>
        </Grid>

        <Grid>
          <Can action={'organizations_c'}>
            <Button
              id="create-new-organization-button"
              onClick={handleOpenOrganizationAddDialog}
              variant="contained"
              color="primary">
              {t('organizations.add')}
            </Button>
          </Can>
        </Grid>
      </Grid>

      <OrganizationsList
        isAddOrganizationDialogOpen={isAddOrganizationDialogOpen}
        onOrganizationAddDialogClose={handleOrganizationAddDialogClose}
        onOrganizationsCountUpdate={handleOrganizationsCountUpdate}
      />
    </Container>
  )
}

export default Organizations
